import Tile from './Tile.jsx'

export default function TileRow({ tiles = [], width = 34, gap = 2, highlightColor, className }) {
  return (
    <div
      className={className}
      style={{ display: 'flex', alignItems: 'flex-end', gap: gap + 'px' }}
    >
      {tiles.map((t, i) => (
        <Tile
          key={i}
          tile={typeof t === 'string' ? { code: t } : t}
          width={width}
          highlightColor={highlightColor}
        />
      ))}
    </div>
  )
}
